/* =========================================================================
   assets/worn-gallery.js
   Worn By — vídeo em hover e galeria fullscreen com scroll horizontal.
   Substitui WornBy.tsx sem reaproveitar nenhuma linha de React.
   ========================================================================= */

class WornGallery extends HTMLElement {
  connectedCallback() {
    this.dialog = this.querySelector('dialog');
    this.scroller = this.querySelector('.worn-modal__scroller');

    /* Reveal escalonado — cada item recebe seu próprio delay. */
    this.querySelectorAll('.worn-item').forEach((item, index) => {
      item.dataset.delay = String((index % 4) * 90);
    });

    /* Hover: só toca o vídeo quando o ponteiro entra (economia de dados). */
    this.querySelectorAll('.worn-item').forEach((item) => {
      const video = item.querySelector('video');
      if (!video) return;
      item.addEventListener('pointerenter', () => {
        video.play().catch(() => {});
      });
      item.addEventListener('pointerleave', () => {
        video.pause();
        video.currentTime = 0;
      });
    });

    this.addEventListener('click', (event) => {
      const trigger = event.target.closest('[data-worn-open]');
      if (!trigger) return;
      event.preventDefault();
      this.open(trigger.dataset.wornOpen);
    });

    this.querySelector('[data-worn-close]').addEventListener('click', () => this.close());
    this.dialog.addEventListener('close', () => document.body.classList.remove('drawer-open'));
  }

  open(handle) {
    const source = this.querySelector(`[data-worn-gallery="${handle}"]`);
    if (!source) return;
    this.scroller.innerHTML = source.innerHTML;
    this.scroller.querySelectorAll('video').forEach((v) => v.play().catch(() => {}));
    document.body.classList.add('drawer-open');
    this.dialog.classList.add('worn-modal');
    this.dialog.showModal();
    this.scroller.scrollLeft = 0;
  }

  close() {
    this.scroller.innerHTML = '';
    this.dialog.close();
  }
}
customElements.define('worn-gallery', WornGallery);
